import React from 'react';
import i18n from '@i18n';
import { scrollBody } from '@/common/client';

export const PopupButton = function({ onClick, message, i18nCode }) {
    const text = message ? message : i18n(i18nCode);
    const addStyleToBody = () => {
        scrollBody(true);
    };
    return (
        <div onClick={addStyleToBody} onChange={addStyleToBody} className="button-handler">
            <a onClick={onClick} className="blue-link">
                {text}
            </a>
        </div>
    );
};
